import ArticlePage from './article'

const articlePage = new ArticlePage()
articlePage.init()
